import React from 'react'

const PageHeader = ({ title, buttonLabel, onButtonClick }) => {
  return (
    <header className="flex justify-between items-center border-b mb-8 pb-4">
      <h1 style={{ width: '80%', fontSize: 20, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>{title}</h1>      
      {buttonLabel && <button className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded' onClick={onButtonClick}>{buttonLabel}</button>}
    </header>
  )
}

export default PageHeader